<script setup lang="ts">
import { Dialog, DialogContent, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  fileName: string;
  fileType: string;
  url: string;
  isActive: boolean;
}

defineProps<Props>();
defineEmits<{ (event: "download"): void; (event: "dismiss"): void }>();
</script>

<template>
  <Dialog :open="isActive" @update:open="!$event && $emit('dismiss')">
    <DialogContent>
      <div class="flex grow items-center justify-center overflow-hidden pt-6">
        <img v-if="fileType.startsWith('image/')" :src="url" class="max-h-full" />
        <video v-if="fileType.startsWith('video/')" :src="url" class="w-full" controls />
      </div>
      <DialogFooter>
        <Button variant="outline" @click="$emit('download')">
          <i class="fa-regular fa-download" />
          {{ fileName }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
